/* This file was generated automatically. Do not edit manually. */

export enum TimeUnitPeriod {
    Day = 'Day',
    Month = 'Month',
    Hour = 'Hour',
}
